import { createDirtyChecker, compareByPaths } from "../gvc/testNewForm/createDirtyChecker";
import { inputToImage } from "./utils";

export function getDirtyChecker(id: string) {
  return createDirtyChecker(id, inputToImage, compareByPaths({
    tags: { path: "tags" },
  }));
}
